import { Profile, PaymentMethod } from 'models'
import Constants from 'api-constants'

/**
 * Create internal account from Backend metadatas
 * @param {Object} userInfo
 * @param {Object} hubProfile
 * @returns {Profile}
 */
export const profileFactory = (userInfo, hubProfile, config = {}) => {
    const { user_id, user_type = '' } = userInfo || {}
    const { name, nickname, email, status = '', hubid } = hubProfile || {}

    let userAccountType
    const userType = user_type.toLowerCase() || status.toLowerCase() || 'lite'
    switch (userType) {
        // This account corresponds to limited account the purchase should be done using credit card
        case 'lite':
            userAccountType = Profile.USER_ACCOUNT_TYPE.LITE
            break
        // This account corresponds to the main account and let the user access to Pay On Bill feature
        case 'main':
        default:
            userAccountType = Profile.USER_ACCOUNT_TYPE.MAIN
            break
    }

    return new Profile({
        userId: user_id,
        firstName: name,
        username: name || nickname,
        // customerId: hubid, // NOTE 28/07/2023 : hudid is email, not TVID. TVID is retrieved from Nagra, no need to overload it here Ufinity-side
        profileId: user_id,
        pcLevel: config.defaultUserPcLevel,
        dvrEnabled: false,
        dvrQuota: 0,
        dvrQuotaRemaining: 0,
        dvrQuotaUnit: Profile.DVR_QUOTA_UNIT.HOUR,
        email: hubid || email,
        status: Profile.STATUS.ACTIVATED,
        userAccountType,
        // For the moment, only ott product is supported
        tvProfile: Constants.eligibility.OTT,
        paymentMethods: resolvePaymentMethods(userAccountType),
        namedProperties: {
            hubId: hubid || email,
            essoId: user_id,
        },
    })
}

/**
 * Create internal account from Backend metadatas
 * @param {Object} userInfo
 * @param {Object} hubProfile
 * @returns {Profile}
 */
export const profileFactoryFromCache = (profileType, essoId, hubId, config = {}) => {
    let userAccountType
    const userType = profileType && profileType.toLowerCase()
    switch (userType) {
        // This account corresponds to limited account the purchase should be done using credit card
        case 'lite':
            userAccountType = Profile.USER_ACCOUNT_TYPE.LITE
            break
        // This account corresponds to the main account and let the user access to Pay On Bill feature
        case 'main':
        default:
            userAccountType = Profile.USER_ACCOUNT_TYPE.MAIN
            break
    }

    return new Profile({
        userId: essoId,
        firstName: hubId, // Not filled when cashed is ussed, fill is with email
        username: hubId, // Not filled when cashed is ussed, fill is with email
        // customerId: hubid, // NOTE 28/07/2023 : hudid is email, not TVID. TVID is retrieved from Nagra, no need to overload it here Ufinity-side
        profileId: essoId,
        pcLevel: config.defaultUserPcLevel,
        dvrQuota: 0,
        dvrQuotaRemaining: 0,
        dvrQuotaUnit: Profile.DVR_QUOTA_UNIT.HOUR,
        email: hubId,
        status: Profile.STATUS.ACTIVATED,
        userAccountType,
        // For the moment, only ott product is supported
        tvProfile: Constants.eligibility.OTT,
        paymentMethods: resolvePaymentMethods(userAccountType),
        namedProperties: {
            hubId: hubId,
            essoId: essoId,
        },
    })
}

/**
 * Resolve Payment methods
 * @param {Profile.USER_ACCOUNT_TYPE} userAccountType
 * @returns {Array<PaymentMethod>}
 */
export const resolvePaymentMethods = (userAccountType) => {
    // Creating fake payment methods for inviting the user to purchase either using
    // billing or credit card depending on the account property
    // The notion of payment method does not really exist in Starhub but this code is for easing
    // the integration with existing upper layers.
    let paymentMethods = []
    if (userAccountType === Profile.USER_ACCOUNT_TYPE.MAIN) {
        paymentMethods.push(
            new PaymentMethod({
                id: 'UfinityPayOnBill',
                name: 'Ufinity',
                defaultPaymentMethod: true,
                paymentPlatform: 'Starhub Billing',
                currency: 'SGT',
                paymentType: PaymentMethod.PAYMENT_METHOD_TYPE.PAY_ON_BILL,
            })
        )
    } else {
        // Payment via credit card has been deferred on Starhub for next milestone, then user need to purchase on Web
        paymentMethods.push(
            new PaymentMethod({
                id: 'UfinityCreditCard',
                name: 'Credit Card',
                defaultPaymentMethod: true,
                paymentPlatform: 'Credit Card',
                currency: 'SGT',
                paymentType: PaymentMethod.PAYMENT_METHOD_TYPE.CREDIT_CARD_USING_SECONDARY_DEVICE,
            })
        )
    }

    return paymentMethods
}
